import queryString from 'query-string';
import groupBy from 'lodash-es';
import api from '../api';
// import router from '../router';

export default {
    namespaced: true,
    state: {
        properties: null,
        property: null
    },
    mutations: {
        properties(state, value) {
            state.properties = value;
        },
        property(state, value) {
            state.property = value;
        },
        offers(state, value) {
            if (state.property) {
                state.property.offers = value;
            }
        }
    },
    getters: {
        notifications(state, getters, rootState) {
            return (state.property && state.property.id && rootState.user.user && rootState.user.user.notifications && rootState.user.user.notifications.filter(notification => notification.target_type === 'property' && notification.target_id === state.property.id)) || [];
        }
    },
    actions: {
        clearProperty({ commit }) {
            return new Promise((resolve) => {
                commit('property', null);
                resolve();
            });
        },
        clearProperties({ commit }) {
            return new Promise((resolve) => {
                commit('properties', null);
                resolve();
            });
        },
        getProperties({ commit }, data) {
            const query = queryString.stringify(data);
            return api.get(`properties${query ? `?${query}` : ''}`)
                .then((response) => {
                    commit('properties', response.data.payload.properties);
                })
                .catch(() => {

                });
        },
        getProperty({ commit, dispatch }, { propertyId, edit = false, clearExisting = true }) {
            const fnGetProperty = () => api.get(`properties/${propertyId}${edit ? '/edit' : ''}`)
                .then((response) => {
                    commit('property', response.data.payload.property);
                    dispatch('user/refreshUser', null, { root: true });
                    return true;
                })
                .catch(error => error.response.status);

            return clearExisting ? dispatch('clearProperty').then(fnGetProperty) : fnGetProperty();
        },
        createProperty({ commit }, data) {
            return api.post('properties', data)
                .then((response) => {
                    //
                })
                .catch(() => {

                });
        },
        updateProperty({ dispatch }, data) {
            return api.patch(`properties/${data.id}`, data);
        },
        deleteProperty({ dispatch }, id) {
            return api.delete(`properties/${id}`);
        },
        createViewingRequest(context, data) {
            return api.post(`properties/${data.id}/events`, data);
        },
        createOffer(context, data) {
            return api.post(`properties/${data.id}/offers`, data);
        },
        uploadPropertyAsset(context, { propertyId, type, file, name }) {
            const data = new FormData();
            data.append('type', type);
            data.append('file', file, name);
            data.append('public', 1);

            return api.post(`properties/${propertyId}/assets`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        deletePropertyAsset(context, { propertyId, id }) {
            return api.delete(`properties/${propertyId}/assets/${id}`);
        },
        reorderImages(context, { propertyId, assets }) {
            return api.patch(`properties/${propertyId}/assets/reorder`, { assets });
        },
        updateAvailability(context, { propertyId, slots }) {
            return api.patch(`properties/${propertyId}/availability`, { slots });
        },
        submitForReview(context, propertyId) {
            return api.patch(`properties/${propertyId}/submit`);
        },
        getOffers({ commit, state }, page = 1) {
            return api.get(`properties/${state.property.id}/offers?page=${page}`)
                .then((response) => {
                    commit('offers', response.data.payload.offers);
                })
                .catch(() => {

                });
        },
        updateOffer(context, data) {
            return api.patch(`properties/${data.propertyId}/offers/${data.offerId}`, data);
        },
        unlistProperty(context, data) {
            return api.patch(`properties/${data.propertyId}/unlist`, data);
        },
        updateViewing(context, data) {
            return api.patch(`events/${data.eventId}`, data);
        },
        processAmlRequest(context, data) {
            return api.get(`owners/${data.ownerId}/${data.confirmationCode}`);
        }
    }
};
